import { type ReactNode } from 'react';
import Autorenew from '@mui/icons-material/Autorenew';
import RobotDead from '@/assets/images/svg/robot-dead.svg';
import { StateMessage } from '@/components/shared/state-message';

interface CardWithErrorProps {
  action: () => void;
  customAction?: ReactNode;
}

export const CardWithError = ({ action, customAction }: CardWithErrorProps) => (
  <StateMessage
    title="Algo deu errado por aqui"
    description="Infelizmente não conseguimos encontrar suas habilidades"
    image={RobotDead}
    imageSize={{ width: 64, height: 64 }}
    action={{
      onClick: action,
      label: 'Tentar novamente',
      startIcon: <Autorenew />,
    }}
    customAction={customAction}
  />
);
